import { useState } from "react";
import { FilterIcon } from "assets/icons";
import "./style.scss";
import Checkbox from "components/BaseWidgets/checkbox";
import Accordion from "components/BaseWidgets/accordion";

function TabFilter({ data = [], isAccordion, onChange }) {
  const [selectedFilters, setSelectedFilters] = useState([]);

  const ALL_LABEL = "All";

  const handleCheckboxChange = (id, checked) => {
    const label = id.split("|")[1];

    let updated;

    setSelectedFilters((prev) => {
      const isAll = label === ALL_LABEL;

      // If selecting ALL → remove everything else
      if (isAll && checked) {
        updated = [`default|${ALL_LABEL}`];
        return updated;
      }

      // If selecting other option while ALL is active → remove ALL
      if (!isAll && prev.includes(`default|${ALL_LABEL}`)) {
        prev = [];
      }

      // Normal multi select toggle
      updated = checked ? [...prev, id] : prev.filter((v) => v !== id);

      return updated;
    });

    // sync selection to parent based on UPDATED values
    setTimeout(() => {
      const current = updated ?? [];
      const allItems = isAccordion
        ? data.flatMap((section) => section.data)
        : data;

      const selectedItems = current
        .map((key) => {
          const l = key.split("|")[1];
          return allItems.find((i) => i.label === l);
        })
        .filter(Boolean);

      // Call parent
      onChange?.(selectedItems);
    });
  };

  const renderCheckboxes = (list, sectionTitle = "") => (
    <div className="flex flex-col gap-3">
      {list.map((item) => {
        const scopedKey = `${sectionTitle}|${item.label}`;
        return (
          <Checkbox
            className="connect-checkbox"
            key={scopedKey}
            isChecked={selectedFilters.includes(scopedKey)}
            onChange={(e) => handleCheckboxChange(scopedKey, e.target.checked)}
          >
            {item.label}
          </Checkbox>
        );
      })}
    </div>
  );

  return (
    <div className="tab-filter">
      <div className="flex items-center gap-2">
        <FilterIcon />
        <span className="font-title-normal">Filter</span>
      </div>

      {isAccordion ? (
        <Accordion
          defaultActiveKey={["0", "1"]}
          accordionClassName="connect-accordion"
          data={data.map((section, i) => ({
            key: i.toString(),
            label: section.title,
            children: renderCheckboxes(section.data, section.title),
          }))}
        />
      ) : (
        renderCheckboxes(data, "default")
      )}
    </div>
  );
}

export default TabFilter;
